/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

import { __ } from '@wordpress/i18n'

const form = document.querySelectorAll("form.citeo-forms-front");

if (form.length > 0) {
    form.forEach((form_value, form_key) => {
        // Validation mention légale (Case à cocher)
        const legacy_input_field = form_value.querySelector('input.form-field-legacy-checkbox');
        if (legacy_input_field) {
            legacy_input_field.addEventListener('change', (event) => {
                if (event.target.checked) {
                    event.target.value = 1;
                } else {
                    event.target.value = 0;
                }
            });
        }
        
        const natureProblemeContent = [...document.querySelectorAll('.citeoforms_multiple_checkbox')].find(el => el.dataset.key === 'natureProbleme');
        if (natureProblemeContent) {
            natureProblemeContent.querySelector('input[defaultvalue="autres"]').addEventListener('change', (event) => {
                const otherInput = natureProblemeContent.querySelector('#other-issue');
                if(event.target.checked) {
                    otherInput.style.display = 'block'
                    otherInput.querySelector('input').required = true;
                } else {
                    otherInput.style.display = 'none'
                }
            })
        }
        
        const submit_btn = form_value.querySelector('#submit-citeo-form');
        submit_btn.addEventListener('click', (event) => {
            event.preventDefault();
            const form_name = form_value.querySelector('.form-title');
            const formData = new FormData();
            formData.append('action', 'send_form_entries');
            // formData.append('nonce', form_value.querySelector('#citeo-forms-nonce').getAttribute('defaultvalue'));
            formData.append('formId', form_name.attributes.data.value);
            formData.append('formName', form_name.textContent);
            formData.append('captcha', form_value.querySelector('input[name=frc-captcha-solution]').value);
            
            const input_field = form_value.querySelectorAll('.citeo-form-input-field');
            const multiple_checkbox_fields = form_value.querySelectorAll('.citeoforms_multiple_checkbox');
            var multiple_checkboxes = {};
            if (multiple_checkbox_fields) {
                multiple_checkbox_fields.forEach((cb_value, cb_key) => {
                    const mbKey = cb_value.dataset.key;
                    const cb_main_label = (mbKey != '') ? mbKey : cb_value.querySelector('label span.help-label').textContent;
                    const cb_inputs = cb_value.querySelectorAll('input');
                    
                    multiple_checkboxes[cb_main_label] = {};
                    multiple_checkboxes[cb_main_label]['field_name'] = cb_main_label;
                    multiple_checkboxes[cb_main_label]['groupName'] = cb_value.querySelector('label span.help-label').textContent;
                    multiple_checkboxes[cb_main_label]['required'] = cb_value.dataset.fieldRequired;
                    multiple_checkboxes[cb_main_label]['key'] = (cb_value.dataset.key != '') ? cb_value.dataset.key : cb_main_label;
                    if (mbKey == 'natureProbleme') {
                        const otherInput = [...cb_value.querySelectorAll('input')].find(el => el.dataset.label === 'autres');
                        if (otherInput && otherInput.checked) {
                            multiple_checkboxes[cb_main_label]['autreInformation'] = cb_value.querySelector('#other-issue').querySelector('input').value;
                        }
                    }

                    cb_inputs.forEach((cb_input_value, cb_input_key) => {
                        let multipleFieldValue = cb_input_value.value;
                        if (cb_input_value.checked) {
                            multipleFieldValue = true;
                        } else {
                            multipleFieldValue = false;
                        }
                        
                        multiple_checkboxes[cb_main_label][cb_input_key] = {};
                        multiple_checkboxes[cb_main_label][cb_input_key]['id'] = cb_input_key+1;
                        multiple_checkboxes[cb_main_label][cb_input_key]['groupName'] = cb_input_value.dataset.fieldName;
                        multiple_checkboxes[cb_main_label][cb_input_key]['name'] = cb_input_value.dataset.label;
                        if (document.querySelector(`label[for="${cb_input_value.id}"]`)) {
                            const originalLabel = document.querySelector(`label[for="${cb_input_value.id}"]`).innerHTML;
                            multiple_checkboxes[cb_main_label][cb_input_key]['originalLabel'] = originalLabel;
                        }
                        
                        multiple_checkboxes[cb_main_label][cb_input_key]['value'] = multipleFieldValue;
                       })
                })

            }

            var fields = {};
            var files = [];
            var multiple_files_name = {};
            input_field.forEach((input_value, input_key) => {
                if(input_value.dataset.type) {
                    fields['multiple_checkboxes'] = multiple_checkboxes;
                } else {
                    fields[input_key] = {};
                    
                    let name = input_value.getAttribute('data-label');
                    let fieldValue = input_value.value;
                    let multiFileValues = null;
                    let key = input_value.getAttribute('data-key');
                    name = name.replace('\\', '');

                    if (input_value.type == 'checkbox') {
                        if (input_value.classList.contains('form-checkbox')) {
                            if (input_value.checked) {
                                fieldValue = true;
                            }    
                        }
                    }

                    if (input_value.type == 'textarea') {
                        fieldValue = input_value.value;
                    }
                    
                    fields[input_key]['id'] = input_key + 1;
                    fields[input_key]['key'] = key;
                    fields[input_key]['name'] = (key != '') ? key : name;
                    fields[input_key]['originalLabel'] = name;
                    fields[input_key]['type'] = input_value.type;
                    fields[input_key]['code'] = input_value.getAttribute('data');
                    fields[input_key]['required'] = input_value.getAttribute('data-required');

                    if (input_value.type == 'file') {
                        if(input_value.getAttribute('data-file-maxsize')) {
                            fields[input_key]['accept'] = input_value.getAttribute('accept');
                            fields[input_key]['maxSize'] = input_value.getAttribute('data-file-maxsize');
                        }
                        
                        if (input_value.files.length != 0) {
                            let randomFile = Date.now() + '_' + (Math.random() + 1).toString(36).substring(2);
                            const fileExtension = input_value.files[0].name.split('.').pop();
    
                            // Si nous sommes dans le cas d multiple fichier
                            if (input_value.hasAttribute('multiple')) {
                                fields['multiple'] = true;    
                                const files = Array.from(input_value.files);
                                fields[input_key]['multiple'] = true;
                                files.forEach((file, key) => {
                                    multiple_files_name[key] = randomFile + '-' + (key+1) + '.' + file.name.split('.').pop();
                                    formData.append('photoArray[]',  file);
                                });
    
                                // Recontruire un tableau en remplaçant les clé numérique par name
                                // cela pour facilité le remplacement les fileName 
                                var assoc = [];
                                Object.values(multiple_files_name).forEach((value, key) => {
                                    assoc.push({ name: value });
                                });
                                  
                                // Remplacer les fileName par les noms du tableau assoc
                                let newFiles = [];
                                Object.values(input_value.files).forEach((value, index) => {
                                    newFiles.push(new File([value], assoc[index].name, { type: value.type }));
                                });
                                
                                fieldValue = multiple_files_name;
                                fields['photoArray'] = newFiles;
                                multiFileValues = newFiles;
                                formData.append(`${fields}[${input_key}]['multiFileValues']`,  multiFileValues);
                                fields[input_key]['multiFileValues'] = multiFileValues;
                            } else {
                                fieldValue = randomFile + '.' + fileExtension;
                                const originalFile = input_value.files[0];
                                
                                const newFile = new File([originalFile], fieldValue, {
                                    type: originalFile.type,
                                    lastModified: originalFile.lastModified,
                                });
                                files.push(newFile);
                                formData.append('fileArray[]',  newFile);
                                fields['multiple'] = false;
                            } 
                        }
                    }
                    fields[input_key]['value'] = fieldValue;
                }
            });

            formData.append('fields', JSON.stringify(fields));           
            var responseClone;

            const formDanger = document.getElementById('form-danger');
            const formSuccess = document.getElementById('form-success');
            const downloadMessage = document.getElementById('download-message');
            fetch('/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: formData,
            }).then(response => {
                responseClone = response.clone();
                return response.json();
            }).then(data => {
                let errors = data.errors;
                const messageError = document.querySelectorAll('.message-error');

                if (errors.length !== 0) {
                    messageError.forEach((message) => {
                        message.style.display = 'none';
                    })
                    
                    let errorMessage = '';
                    Object.entries(errors).forEach(([key, value]) => {
                        if (key != 'captcha') {
                            const errorId = document.getElementById(key);
                            if (errorId) {
                                errorId.innerHTML = value;
                                errorId.style.display = 'block';
                            }
                        } else {
                            
                            errorMessage += '<div class="citeo-form-error">';
                            errorMessage += `${data.errors.captcha}`;
                            errorMessage += '</div>';
                        }
                        
                        
                        // if (key == 'size_files') {
                        //     const uploadInputs = document.querySelectorAll('.citeo-forms-field-file');
                        //     uploadInputs.forEach(wrap => {
                        //         const isAdded = wrap.querySelector('.field-error');
                        //         const dropzone = wrap.querySelector('.dropzone');
                        //         if(!isAdded) {
                        //             const errorElem = document.createElement('span');
                        //             errorElem.classList.add('field-error', 'Body-3');
                        //             errorElem.innerText = value;
                        //             dropzone.parentElement.insertBefore(errorElem, dropzone)
                        //         }
                        //     })
                        // }
                    })

                    formSuccess.style.display = 'none';
                    formDanger.style.display = 'block';
                    formDanger.innerHTML = errorMessage;

                    // Cherche la première erreur visible
                    const firstVisibleError = Array.from(messageError).find(
                        (el) => el.style.display != 'none'
                    );

                    if (firstVisibleError) {
                        firstVisibleError.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                        });

                        const input = firstVisibleError.previousElementSibling;
                        if (input && input.tagName === "INPUT") {
                            input.focus();
                        }
                    }
                    friendlyChallenge.autoWidget.reset();
                } else {
                    input_field.forEach((input_value) => {
                        input_value.value = '';
                        if (input_value.type == 'checkbox') {
                            input_value.checked = false;
                        }
                    });
                    document.querySelector('.field-error')?.remove();
                    formDanger.style.display = 'none';
                    formSuccess.style.display = 'block';
                    const downloadSection = document.querySelector('#download-section');
                    const formRows = document.querySelectorAll('.citeo-forms-field');
                    const captchaSection = document.querySelector('.frc-captcha');
                    const citeoFormButton = document.querySelector('#citeo-forms-block-button');
                     messageError.forEach((message) => {
                        message.style.display = 'none';
                    })

                    formSuccess.innerHTML = data.successMessage;
                     // Reset uploaded thumbnails
                     const allThumbs = form_value.querySelectorAll('.thumb')
                     // Show default thumb icon
                     form_value.querySelectorAll('.no-thumb').forEach(el => {
                         el.style.display = 'block';
                     });
                     allThumbs.forEach(thumb => {
                         thumb.remove();
                     });
                    if (downloadSection) {
                        formRows.forEach((field_value, field_key) => {
                            field_value.style.display = 'none';
                        });
                        formSuccess.style.display = 'none';
                        captchaSection.style.display = 'none';
                        citeoFormButton.style.display = 'none';
                        downloadMessage.style.display = 'block';
                        downloadMessage.innerHTML = downloadSection.innerHTML;
                    }
                    if (natureProblemeContent) {
                        const otherInput = natureProblemeContent.querySelector('#other-issue');
                        otherInput.value = '';
                        otherInput.style.display = 'none'
                    }
                    friendlyChallenge.autoWidget.reset();
                }
            }, (rejectionReason) => { 
                console.error('Error parsing JSON from response : ', rejectionReason);
                responseClone.text()
                .then((bodyText) => {
                    console.error('Received the following instead of valid JSON : ', bodyText);
                });
            });
        });
    })

    /*
    *   UPLOAD MANAGEMENT
    */
    const uploadInputs = document.querySelectorAll('.citeo-forms-field-file');

    uploadInputs.forEach(wrap => {
        // Global object to keep track of previously uploaded files discarded on input change
        let filesUploaded = [];

        const   noThumb = wrap.querySelector('.no-thumb'),
                fileContainer = wrap.querySelector('.thumb-container'),
                dropzone = wrap.querySelector('.dropzone'),
                inputElem = wrap.querySelector('input[type="file"]'),
                captcha_btn = document.querySelector('.citeo-forms-front .frc-button') 
    

        const removeFile = (thumb) => {
            // Get input associated to the current node
            const thumbs = [...wrap.querySelectorAll('.thumb')]
            const index = thumbs.indexOf(thumb)

            // Filter passed index from the file list and reassign it to the input via dataTransfer object
            inputElem.files = [...inputElem.files].reduce((dt, f, i) => {
                if(i !== index) {
                    dt.items.add(f);
                }
                return dt;
            }, new DataTransfer()).files;

            // Remove file from global file object
            filesUploaded = filesUploaded.filter((_, i) => i !== index);

            // Remove file thumb from the DOM
            thumb.remove();
            
            if (captcha_btn) captcha_btn.click()

            // Display the no file icons if no files are found
            if(filesUploaded.length < 1) noThumb.style.display = 'block';
        }


        const generateThumb = (file) => {
            // Add new file to the global file list
            filesUploaded.push(file);

            // Create image wrapper
            const imgWrapper = document.createElement('div');
            imgWrapper.classList.add('thumb');
            imgWrapper.title = file.name;

            // Create thumb remove btn
            const closeBtn = document.createElement('div');
            closeBtn.classList.add('remove-thumb');
            imgWrapper.appendChild(closeBtn);

            closeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const thumb = e.target.parentElement;
                const uuid = thumb.dataset.uuid
                removeFile(thumb);
            })

            // Check if the file type is an image to generate a preview from <img>
            if(file.type.indexOf('image') > -1) {
                const imgTarget = document.createElement('img');

                const objectURL = URL.createObjectURL(file);
                imgTarget.src = objectURL;

                imgWrapper.appendChild(imgTarget);
            } else {
                imgWrapper.classList.add('default-thumb');

                const nameWrapper = document.createElement('span');
                nameWrapper.classList.add('Body-3');
                nameWrapper.innerText = file.name;

                imgWrapper.appendChild(nameWrapper);
            }
            // Add thumbnail to the DOM
            fileContainer.appendChild(imgWrapper);
            if (captcha_btn) captcha_btn.click()
        }


        const handleInput = (fileList) => {
            // Remove old thumbs to match native input behavior on change
            noThumb.style.display='none';

            // Generate the thumbnail for each file
            [...fileList].forEach(file => {
                generateThumb(file);
            });

            if(fileList.length !== filesUploaded.length) {
                inputElem.files = filesUploaded.reduce((dt, f) => {
                    dt.items.add(f);

                    return dt;
                }, new DataTransfer()).files;
            }
        }


        inputElem.addEventListener('change', (ev) => handleInput([...ev.target.files]));

        // Drag event to hook styling
        dropzone.addEventListener('dragleave', (ev) => {
            ev.stopPropagation();
            dropzone.classList.remove('drag-over')
        });
        dropzone.addEventListener('dragover', (ev) => {
            ev.preventDefault();
            if(!dropzone.classList.contains('drag-over')) {
                dropzone.classList.add('drag-over')
            }
        })

        dropzone.addEventListener('drop', (ev) => {
            ev.preventDefault();

            let files = []
            if (ev.dataTransfer.items) {
                // Use DataTransferItemList interface to access the file(s)
                [...ev.dataTransfer.items].forEach((item) => {
                    // If dropped items aren't files, reject them
                    if (item.kind === "file") {
                        const file = item.getAsFile();
                        files.push(file);
                    }
                });
            } else {
                // Use DataTransfer interface to access the file(s)
                [...ev.dataTransfer.files].forEach((file) => {
                    files.push(file);
                });
            }

            handleInput(files);
            dropzone.classList.remove('drag-over');
        });
    });
}